import $ from 'jquery';

export default class LoadPosts {
  constructor({ action = 'load_posts', postType = 'post', postsToLoad = 6, taxonomy = '', term_id = '' } = {}) {
    this.action = action;
    this.postType = postType;
    this.postsToLoad = postsToLoad;
    this.pageNumber = 1;
    this.taxonomy = taxonomy;
    this.term_id = term_id;

    this.updateData();
  }

  updateData() {
    this.data = {
      action: this.action,
      post_type: this.postType,
      page_number: this.pageNumber,
      posts_to_load: this.postsToLoad,
      taxonomy: this.taxonomy,
      term_id: this.term_id
    }
  }

  getPageNumber() {
    return this.pageNumber;
  }

  increasePageNumber() {
    this.pageNumber += 1;
  }

  updatePostsLoaded() {
    this.postsLoaded += this.postsToLoad;
  }

  setTermID(id) {
    this.term_id = id;
  }

  fetchPosts() {
    this.updateData();
    this.increasePageNumber();
    this.updatePostsLoaded();

    return new Promise(resolve => {
      $.post(main_theme_objects.ajax_url, this.data, (response) => {
        if (response != 0) {
          resolve(response);
        }
      });
    });
  }
}


// WEBPACK FOOTER //
// ./resources/js/utils/_load-posts.js